import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { fmtBRL } from '../../db/api.js'

const modes = { percentual: 'Percentual', valor: 'Valor do desconto', final: 'Valor final do item' }
export default function DealItemDiscountDialog({ item, onApply, onClose }) {
  const dialog = useRef(null)
  const [mode, setMode] = useState('percentual')
  const [value, setValue] = useState(item.desconto_percentual ? Number(item.desconto_percentual).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) : '')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const total = Number(item.valor_total || 0)
  const number = Number(value.includes(',') ? value.replace(/\./g, '').replace(',', '.') : value)
  const valid = value.trim() && Number.isFinite(number) && number >= 0 && number <= (mode === 'percentual' ? 100 : total)
  const percent = mode === 'percentual' ? number : total > 0 ? (mode === 'final' ? total - number : number) / total * 100 : 0
  const discounted = Math.round(total * (1 - percent / 100) * 100) / 100
  useEffect(() => { dialog.current?.showModal() }, [])
  async function submit(event) {
    event.preventDefault()
    if (!valid) { setError(mode === 'percentual' ? 'Informe um percentual entre 0 e 100.' : 'Informe um valor entre zero e o total do item.'); return }
    if (saving) return
    setSaving(true); setError('')
    try { await onApply(percent); onClose() } catch (err) { setError(err.message); setSaving(false) }
  }
  return createPortal(<dialog ref={dialog} className="dp-discount-dialog" aria-labelledby="dp-discount-title" onCancel={(event) => { event.preventDefault(); if (!saving) onClose() }} onKeyDown={(event) => { if (event.key === 'Escape') event.stopPropagation() }} onClick={(event) => { if (event.target === event.currentTarget && !saving) onClose() }}>
    <form onSubmit={submit}>
      <h2 id="dp-discount-title">Desconto do item</h2>
      <p>{item.catalogo_nome || item.descricao || 'Item'} · {fmtBRL(total)}</p>
      <div className="dp-discount-modes" aria-label="Forma de desconto">{Object.entries(modes).map(([key, label]) => <button type="button" key={key} aria-pressed={mode === key} disabled={saving} onClick={() => { setMode(key); setValue(''); setError('') }}>{label}</button>)}</div>
      <label htmlFor="dp-discount-value">{modes[mode]} {mode === 'percentual' ? '(%)' : '(R$)'}</label>
      <input id="dp-discount-value" autoFocus inputMode="decimal" autoComplete="off" placeholder="0,00" value={value} disabled={saving} onChange={(event) => { setValue(event.target.value); setError('') }} />
      {valid && <div className="dp-discount-preview"><span>Total com desconto</span><strong>{fmtBRL(discounted)}</strong></div>}
      {error && <p role="alert">{error}</p>}
      <div className="dp-discount-actions"><button type="button" disabled={saving} onClick={onClose}>Cancelar</button><button type="submit" disabled={saving}>{saving ? 'Aplicando…' : 'Aplicar desconto'}</button></div>
    </form>
  </dialog>, document.body)
}
